export const ONLY_JPG_OR_PNG_ALLOWED = {
  pt: "Apenas imagens JPG ou PNG são permitidas",
  en: "Only JPG or PNG images are allowed",
  es: "Solo se permiten imágenes JPG o PNG",
};

export const LIMIT_IMAGES_MESSAGE = (limit: number, current: number) => ({
  pt: `O limite de imagens é ${limit}. Adicione apenas mais ${
    limit - current
  }.`,
  en: `The image limit is ${limit}. You can only add ${limit - current} more.`,
  es: `El límite de imágenes es ${limit}. Solo puedes agregar ${
    limit - current
  } más.`,
});

export const UPLOAD_IMAGE_SUCCESS_MESSAGE = (name: string) => ({
  pt: `Upload da imagem "${name}" realizado com sucesso!`,
  en: `Image "${name}" uploaded successfully!`,
  es: `¡Imagen "${name}" cargada con éxito!`,
});

export const UPLOAD_IMAGE_ERROR_MESSAGE = (name: string) => ({
  pt: `Erro ao realizar upload da imagem "${name}"`,
  en: `Error uploading image "${name}"`,
  es: `Error al cargar la imagen "${name}"`,
});

export const IMAGE_ALT = {
  pt: "Imagem da galeria",
  en: "Gallery image",
  es: "Imagen de la galería",
};

export const INSERT_DESCRIPTION_OPTIONAL = {
  pt: "Inserir descrição (opcional)",
  en: "Insert description (optional)",
  es: "Insertar descripción (opcional)",
};

export const INSERT_DESCRIPTION = {
  pt: "Descrição da imagem",
  en: "Image description",
  es: "Descripción de la imagen",
};

export const REMOVE = {
  pt: "Remover",
  en: "Remove",
  es: "Eliminar",
};

export const GALLERY_IMAGES_LABEL = (
  current: number | string,
  limit: number
) => ({
  pt: `Galeria: ${current}/${limit} imagens`,
  en: `Gallery: ${current}/${limit} images`,
  es: `Galería: ${current}/${limit} imágenes`,
});

export const DROP_IMAGES_HERE = {
  pt: "Solte as imagens aqui",
  en: "Drop images here",
  es: "Suelta las imágenes aquí",
};

export const OR_CLICK_TO_UPLOAD = {
  pt: "ou clique para fazer o upload",
  en: "or click to upload",
  es: "o haz clic para cargar",
};

export const LOADING = {
  pt: "Carregando...",
  en: "Loading...",
  es: "Cargando...",
};
